export const galerija = [
  {
    id: "notranjost",
    naslov: "Notranjost bara",
    opis: "Topli toni, les in mehka svetloba.",
    slika:
      "https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/b6e4f8fb9a86e0a1b5ef39f8efb8faa2.png",
    alt: "Notranjost Bara Stanka na Ptuju z lesenimi mizami, črnimi stoli in poslikavo mesta na steni",
    span: "col-span-2 row-span-2",
  },
  {
    id: "terasa",
    naslov: "Terasa",
    opis: "Miren kotiček ob trgu.",
    slika:
      "https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/2098f58add7cf32a535f97c2ae881241.png",
    alt: "Zunanja terasa Bara Stanka na Ptuju z lesenimi mizami, ograjo in velikimi steklenimi okni",
    span: "col-span-2 row-span-1",
  },
  {
    id: "detalji",
    naslov: "Detajli",
    opis: "Majhne podrobnosti, ki štejejo.",
    slika:
      "https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/7428bc171bea713a046a30ccdda0094f.png",
    alt: "Skodelica kave z latte artom na leseni mizi pred oknom Bara Stanka",
    span: "col-span-2 row-span-2",
  },
  {
    id: "ambient",
    naslov: "Ambient",
    opis: "Prostor za čas zase.",
    slika:
      "https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/b36a7a07793c657a379b7573f5242e4a.png",
    alt: "Ambient Bara Stanka na Ptuju z barskim pultom, visečimi lučmi in lesenimi mizami",
    span: "col-span-2 row-span-1",
  },
];